import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAplicationFormProcess,
  getApplicationSchoolProcessData,
  getFormReqByiD,
  postAplicationFormReq,
  postAplicationFormReq2,
  postContactusForm,
  postFileUploadData,
  putFileUploadData,
  postOfferAcceptance,
} from "@/parentService/parentApi";

interface initialStateType {
  clearStorage: boolean;
  isClick: boolean;
  profileSave: boolean;
  familyDetails: any;
  studentDetails: any;
  selectedOption: string;
  studentInfo: any;
  // currentStep: number;
  selectedPerson: string;
  loader: boolean;
  applicationFormData: any;
  parentInfoFormData: any;
  previousSchoolFormData: any;
  academicInfo: any;
  OtherDetailsForm: any;
  fileInfo: any;
  OtherDetailsGetData: any;
  loading: boolean;
  fileDetailsGetData: any;
  contactForm: any;
  viewApplication: any;
  deleteFiles: any;
}

const initialState: initialStateType = {
  clearStorage: false,
  isClick: false,
  profileSave: false,
  familyDetails: null,
  studentDetails: null,
  selectedOption: "",
  studentInfo: null,
  // currentStep: 0,
  selectedPerson: null,
  loader: false,
  applicationFormData: null,
  parentInfoFormData: null,
  previousSchoolFormData: null,
  academicInfo: null,
  OtherDetailsForm: null,
  fileInfo: null,
  OtherDetailsGetData: null,
  loading: false,
  fileDetailsGetData: null,
  contactForm: null,
  viewApplication: null,
  deleteFiles: null,
};

export const getStudentInformationData: any = createAsyncThunk(
  "data/getStudentInformationData",
  async ({id,userId}:any, { dispatch }) => {
    try {
       dispatch(setLoading(true));
      let data = await getAplicationFormProcess(`/student-details`, `${id}/${userId}`);

      // dispatch(setApplicationFormData(data?.data));
       dispatch(setLoading(false));
      return data;
    } catch (error) {
      console.log("error --->", error);
      //  dispatch(setLoading(false));
      //  throw error ;
    }
  }
);

export const getParentInformationData: any = createAsyncThunk(
  "data/getParentInformationData",
  async ({id,userId}:any, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      let data = await getAplicationFormProcess(`/family-details`, `${id}/${userId}`);
      // dispatch(setParentInfoFormData(data?.data));
      dispatch(setLoading(false));
      return data;
    } catch (error) {
      dispatch(setLoading(false));
      throw error;
    }
  }
);

export const getPreviousSchoolData: any = createAsyncThunk(
  "data/getPreviousSchoolData",
  async ({id,userId}:any, { dispatch }) => {
    try {
      let data = await getApplicationSchoolProcessData(
        `/past-high-school`,
        `${id}/${userId}`
      );

      return data;
    } catch (error) {
      console.log("error --->", error);
    }
  }
);

export const getAcademicForm: any = createAsyncThunk(
  "data/getAcademicForm",
  async (formData, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      let data = await postAplicationFormReq2(`/academic-details`, formData);

      // dispatch(setAcademicInfo(data?.data?.data))
      dispatch(setLoading(false));
      return data;
    } catch (error) {
      dispatch(setLoading(false));
      throw error;
    }
  }
);

export const postOtherDetailsForm: any = createAsyncThunk(
  "data/postOtherDetailsForm",
  async (formData, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let data = await postAplicationFormReq2(`/other-details`, formData);
      dispatch(setOtherDetailsForm(data?.data));
      dispatch(setLoader(false));
      return data;
    } catch (error) {
      dispatch(setLoader(false));
      throw error;
    }
  }
);

export const postFileDetails: any = createAsyncThunk(
  "data/postFileDetails",
  async (formData, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let data = await postFileUploadData(`/file-upload`, formData);
      dispatch(setFileInfo(data?.data));
      dispatch(setLoader(false));
      return data;
    } catch (error) {
      dispatch(setLoader(false));
      throw error;
    }
  }
);

export const postSupportFileDetails: any = createAsyncThunk(
  "data/postSupportFileDetails",
  async (formData, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let data = await putFileUploadData(`/support/documents`, formData);
      // dispatch(setFileInfo(data?.data))
      dispatch(setLoader(false));
      return data;
    } catch (error) {
      dispatch(setLoader(false));
      throw error;
    }
  }
);

export const getOtherDetailsForm: any = createAsyncThunk(
  "data/getOtherDetailsForm",
  async ({id,userId}:any, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      let { data } = await getFormReqByiD(`/other-details`, `${id}/${userId}`);
      // dispatch(setOtherDetailsGetData(data?.data))
      dispatch(setLoading(false));
      return data;
    } catch (error) {
      dispatch(setLoading(false));
      throw error;
    }
  }
);

export const getFileDetails: any = createAsyncThunk(
  "data/getFileDetails",
  async ({id,userId}:any, { dispatch }) => {
    try {
    
      let { data } = await getFormReqByiD(`/support/documents`, `${id}/${userId}`);

      dispatch(setFileDetailsGetData(data?.data));
  
      return data;
    } catch (error) {
console.log('error --->', error);
  

    }
  }
);

export const parentContactUsForm: any = createAsyncThunk(
  "data/parentContactUsForm",
  async (formValue, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      let { data } = await postContactusForm(`/leads`, formValue);

      dispatch(setContactForm(data?.data));
      dispatch(setLoading(false));
      return data;
    } catch (error) {
      dispatch(setLoading(false));
      throw error;
    }
  }
);

export const getViewApplication: any = createAsyncThunk(
  "data/getViewApplication",
  async ({id,userId}:any, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      let { data } = await getFormReqByiD(`/view/application`, `${id}/${userId}`);
      dispatch(setLoading(false));
      return data;
    } catch (error) {
      dispatch(setLoading(false));
      console.log("✌️error --->", error);
    }
  }
);

export const postDeleteFiles: any = createAsyncThunk(
  "data/postDeleteFiles",
  async (formData, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let data = await postAplicationFormReq(
        `/support/documents/remove-file`,
        formData
      );
      // dispatch(setDeleteFiles(data?.data))
      dispatch(setLoader(false));
      return data;
    } catch (error) {
      dispatch(setLoader(false));
      throw error;
    }
  }
);

export const updateOfferAcceptance: any = createAsyncThunk(
  "data/updateOfferAcceptance",
  async (formData, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let data = await postOfferAcceptance(`/update-acknowledge`, formData);
      dispatch(setLoader(false));
      return data;
    } catch (error) {
      dispatch(setLoader(false));
      throw error;
    }
  }
);

export const applicationProcess = createSlice({
  name: "application",
  initialState,
  reducers: {
    setClearStorage: (state: initialStateType, action) => {
      state.clearStorage = action.payload;
    },
    setIsClick: (state: initialStateType, action) => {
      state.isClick = action.payload;
    },
    setProfileSave: (state: initialStateType, action) => {
      state.profileSave = action.payload;
    },
    setFamilyDetails: (state: initialStateType, action) => {
      state.familyDetails = action.payload;
    },
    setStudentDetails: (state: initialStateType, action) => {
      state.studentDetails = action.payload;
    },
    setSelectedOption: (state: initialStateType, action) => {
      state.selectedOption = action.payload;
    },
    setStudentInfo: (state: initialStateType, action) => {
      state.studentInfo = action.payload;
    },
    // setCurrentStep: (state: initialStateType, action) => {
    //   state.currentStep = action.payload;
    // },
    setSelectedPerson: (state: initialStateType, action) => {
      state.selectedPerson = action.payload;
    },
    setLoader: (state: initialStateType, action) => {
      state.loader = action.payload;
    },
    setApplicationFormData: (state: initialStateType, action) => {
      state.applicationFormData = action.payload;
    },
    setParentInfoFormData: (state: initialStateType, action) => {
      state.parentInfoFormData = action.payload;
    },
    setPreviousSchoolFormData: (state: initialStateType, action) => {
      state.previousSchoolFormData = action.payload;
    },
    setAcademicInfo: (state: initialStateType, action) => {
      state.academicInfo = action.payload;
    },
    setOtherDetailsForm: (state: initialStateType, action) => {
      state.OtherDetailsForm = action.payload;
    },
    setFileInfo: (state: initialStateType, action) => {
      state.fileInfo = action.payload;
    },
    setOtherDetailsGetData: (state: initialStateType, action) => {
      state.OtherDetailsGetData = action.payload;
    },
    setLoading: (state: initialStateType, action) => {
      state.loading = action.payload;
    },
    setFileDetailsGetData: (state: initialStateType, action) => {
      state.fileDetailsGetData = action.payload;
    },
    setContactForm: (state: initialStateType, action) => {
      state.contactForm = action.payload;
    },
    setViewApplication: (state: initialStateType, action) => {
      state.viewApplication = action.payload;
    },
    setDeleteFiles: (state: initialStateType, action) => {
      state.deleteFiles = action.payload;
    },
  },
});

export const {
  setClearStorage,
  setIsClick,
  setProfileSave,
  setFamilyDetails,
  setStudentDetails,
  setSelectedOption,
  setStudentInfo,
  // setCurrentStep,
  setSelectedPerson,
  setLoader,
  setApplicationFormData,
  setParentInfoFormData,
  setPreviousSchoolFormData,
  setAcademicInfo,
  setOtherDetailsForm,
  setFileInfo,
  setOtherDetailsGetData,
  setLoading,
  setFileDetailsGetData,
  setContactForm,
  setViewApplication,
  setDeleteFiles,
} = applicationProcess.actions;

export default applicationProcess.reducer;
